<nz-row nzGutter="24">
  <nz-col [nzSm]="24">
    <r-widget-control [control]="firstnameControl">
      <input
        nz-input
        [name]="config.name"
        [placeholder]="config.placeholder"
        [(ngModel)]="config.value"
        (ngModelChange)="onChange($event)"
        [required]="config.required"
        [disabled]="config.disabled"
        ngDefaultControl
        #firstnameControl="ngModel"
      />
    </r-widget-control>
  </nz-col>
  <nz-col [nzSm]="24" *ngIf="config.fixedValue">
    <app-fixed-display [config]="config"> </app-fixed-display>
  </nz-col>
</nz-row>
